import { useEffect, useState } from 'react';

export function useCarousel<T>(data: T[]) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const totalSlides = data.length;

  useEffect(() => {
    if (totalSlides <= 1 || isPaused) return;

    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    }, 4000);

    return () => clearInterval(timer);
  }, [totalSlides, isPaused]);

  const goToSlide = (index: number) => {
    if (index >= 0 && index < totalSlides) {
      setCurrentSlide(index);
    }
  };

  const pause = () => setIsPaused(true);
  const resume = () => setIsPaused(false);

  const currentData = data[currentSlide];

  return {
    currentIndex: currentSlide,
    currentData,
    totalSlides,
    goToSlide,
    pause,
    resume,
  };
}
